import React from 'react';
import { NavLink } from 'react-router-dom';

const TasksList = () => {
	return (
		<ul className="task-list list-unstyled">
			{/* TODO - Refactor this list in all 800 places so that it is only defined once. */}
			<li><NavLink to={'/getting-started/simple-tasks/get-user'}>Get a User</NavLink></li>
			<li><NavLink to={'/getting-started/simple-tasks/get-post'}>Get a Post</NavLink></li>
			{/*<li><NavLink to={'/getting-started/simple-tasks/get-stream'}>Get a Stream</NavLink></li>*/}
			<li><NavLink to={'/getting-started/simple-tasks/manage-targets'}>Manage Targets</NavLink></li>
			<li><NavLink to={'/getting-started/simple-tasks/preregister-user'}>Preregister a User</NavLink></li>
			<li><NavLink to={'/getting-started/simple-tasks/share-post'}>Share a Post</NavLink></li>
			<li><NavLink to={'/getting-started/simple-tasks/upload-profile-image'}>Upload a Profile Image</NavLink></li>
			<li><NavLink to={'/getting-started/simple-tasks/upload-video'}>Upload a Video</NavLink></li>
			<li><NavLink to={'/getting-started/simple-tasks/update-user'}>Update a User</NavLink></li>
		</ul>
	);
};

export default TasksList;


// WEBPACK FOOTER //
// ./src/components/getting-started/SimpleTasksList.js